// extracted by mini-css-extract-plugin
module.exports = {"root":"_2UoJ-5xSJZVc","active":"I9MfXD2OsFOL","label":"JqiaSWOQ4WbF","icon":"_3R68-yyrzJcs"};